import { InboxOutlined, UploadOutlined } from '@ant-design/icons';
import { Button, Card, Col, Form, Image, Modal, Row, Spin, Upload, UploadProps } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import { openNotificationWithIcon } from 'app/components/PopupNotification';
import TooltipMultipleParagraph from 'app/components/TooltipMultipleParagraph';
import { getListTestStepRunAPI, getTestStepRunDetailAPI, updateTestStepRun } from 'app/services/api/execute';
import { useAppDispatch, useAppSelector } from 'app/store';
import React, { useCallback, useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { setTestCaseStep, setTestStepDetailDefect, setTestStepId, triggerIsUpdateTestCase } from '../../Execute.slice';
import { ITestStepRun, statusTestStep } from '../../Execute.type';
import './ExecuteTestCase.scss';
import { RcFile } from 'antd/lib/upload';

const ExecuteTestCase = () => {
  const isUpdateTestCase = useAppSelector(state => state.execute.isUpdateTestCase);

  const dispatch = useAppDispatch();
  const location = useLocation();
  const [form] = Form.useForm();
  const url = new URLSearchParams(location.search);
  const execuTetestCaseId: any = url.get('execuTetestCaseId');
  const testCaseRunId: any = url?.get('testCaseRunId');

  const [previewImage, setPreviewImage] = useState('');
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [endCallUpdate, setEndCallUpdate] = useState<boolean>(false);
  const [fileObject, setFileObject] = useState<any>();
  const [source, setSource] = useState<any>();
  const [testStepDeatil, setTestStepDeatil] = useState<ITestStepRun>();
  const [idNextTestStep, setIdNextTestStep] = useState<number | null>(null);
  const [idPreviousStep, setIdPreviousStep] = useState<number | null>(null);
  const [formData, setFormData] = useState<any>();
  const testStepDetailDefect = useAppSelector(state => state.execute.testStepDetailDefect);
  const [actualResult, setActualResult] = useState<string>();
  const [testStepRunID, setTestStepRunID] = useState<number | string | null>(url.get('testStepRunID'));
  const [testCaseDetailTitle, setTestCaseDetailTitle] = useState<string>('');
  const [infoFileName, setInfoFileName] = useState<any>();
  const [fileType, setFileType] = useState('');
  const [checkValidateFile, setCheckValidateFile] = useState(false);
  const [errorText, setErrorText] = useState('');
  const props: UploadProps = {
    beforeUpload: file => {
      return false;
    },
  };
  const handleTitleTestCase = useCallback(async () => {
    if (testCaseRunId) {
      const res = await getListTestStepRunAPI(testCaseRunId, execuTetestCaseId);
      setTestCaseDetailTitle(res?.testCaseTitle);
    }
  }, [testCaseRunId, execuTetestCaseId]);

  useEffect(() => {
    handleTitleTestCase();
  }, [handleTitleTestCase]);

  const handleUpdateTestStepRun = (status?: string) => {
    if (isLoading || (!status && !formData)) return;
    setIsLoading(true);
    form.validateFields().then(async () => {
      let newFormData: any = new FormData();
      newFormData.append('TestStepRunId', testStepDeatil?.testStepRunId);
      newFormData.append('StatusType', status == 'Not Run' ? 'Not Started' : status ?? testStepDeatil?.statusType);
      newFormData.append('ActualResult', formData?.actualResult ?? testStepDeatil?.actualResult ?? '');
      newFormData.append('IsUpdateAttachment', false);
      newFormData.append('Attachment', formData?.attachment);
      try {
        const res = await updateTestStepRun(newFormData);
        dispatch(triggerIsUpdateTestCase());
        openNotificationWithIcon('success', res.message);
        setIsLoading(false);
        setEndCallUpdate(true);
      } catch (error: any) {
        openNotificationWithIcon('error', error?.message ? error.message : 'File format is not valid');
        setIsLoading(false);
        setEndCallUpdate(false);
      }
    });
  };

  useEffect(() => {
    handleUpdateTestStepRun();
  }, [formData]);

  const handleChangeActualResult = e => {
    setActualResult(e.target.value);
  };

  const handleBlurActualResult = e => {
    setFormData(pre => ({ ...pre, actualResult: e.target.value }));
  };

  /* Hanlde Next Or Prev Step */
  const handleNextOrPrevTestCase = (type: string) => {
    setPreviewImage('');
    setFormData(undefined);
    const idToSet = type === 'next' ? idNextTestStep : idPreviousStep;
    if (idToSet) {
      const urlParams = new URLSearchParams(window.location.search);
      urlParams.set('testStepRunID', String(idToSet));
      setTestStepRunID(idToSet);
      const newURL = `${window.location.origin}${window.location.pathname}?${urlParams.toString()}`;
      window.history.replaceState({}, '', newURL);
    }
  };

  const getTestStepRunDeatil = async () => {
    try {
      const res = await getTestStepRunDetailAPI(testStepRunID as any, testCaseRunId as any);
      if (res?.data?.attachmentMimeType?.includes('image/')) {
        setFileType('image');
      } else if (res?.data?.attachmentMimeType?.includes('video/')) {
        setFileType('video');
      } else {
        setFileType('');
      }
      setTestStepDeatil(res?.data);
      dispatch(setTestStepDetailDefect(res?.data));
      localStorage.setItem(`testStepDetailDefect`, JSON.stringify(res?.data));
      // dispatch(setTestCaseStep(res?.data));
      setIdNextTestStep(res?.nextStep);
      setIdPreviousStep(res?.previousStep);
      setActualResult(res?.data?.actualResult);

      setPreviewImage(res.data?.attachmentUrl);
    } catch (error) {}
  };
  const openModalCreateDefect = () => {
    localStorage.setItem(`open-modal`, `open-modal-${Date.now().toString()}`);
    localStorage.setItem(`actualResult`, actualResult as any);
    window.close();
  };

  useEffect(() => {
    if (endCallUpdate && localStorage.getItem('open-modal')?.includes('open-modal')) {
      window.close();
    }
  }, [endCallUpdate, actualResult]);

  const handleChangeStatus = (value: string) => {
    const status = value == 'Not Run' ? 'Not Started' : value;
    handleUpdateTestStepRun(status);
  };

  const handleDragOver = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault(); // Ngăn chặn hành vi mặc định
  };

  const handleDrop = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault(); // Ngăn chặn mở ảnh trong tab mới
  };

  const handleChangeUpload = event => {
    setCheckValidateFile(false);
    setErrorText('');
    const MAX_FILE_SIZE_MB = 75;
    const MAX_FILE_SIZE = MAX_FILE_SIZE_MB * 1024 * 1024; // đổi sang byte
    if ((event?.file?.size as any) > MAX_FILE_SIZE) {
      setCheckValidateFile(true);
      setErrorText('The file is too large. Maximum allowed size is 75MB.');
      return;
    } else {
      setErrorText('');
    }
    if (event?.file.type?.includes('image/')) {
      setFileType('image');
    } else if (event?.file.type?.includes('video/')) {
      setFileType('video');
    } else {
      setFileType('');
    }
    setPreviewImage('');
    getBase64WithCallback(event.file as RcFile, url => {
      setPreviewImage(url);
      setFileObject(event.file);
      setFormData(pre => ({ ...pre, attachment: event.file }));
      setSource(url);
    });
  };

  const getBase64WithCallback = (img: RcFile, callback: (url: string) => void) => {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result as string));
    reader.readAsDataURL(img);
  };

  const handleUpLoad = file => {
    if (file) {
      getBase64WithCallback(file as RcFile, url => {
        setPreviewImage(url);
        setFileObject(file);
        setFormData(pre => ({ ...pre, attachment: file }));
        setSource(url);
      });
    }
  };

  useEffect(() => {
    const handlePaste = event => {
      const items = event.clipboardData.items;
      for (const item of items) {
        if (item.type.startsWith('image/')) {
          setFileType('image');
          const imageFile = item.getAsFile();
          handleUpLoad(imageFile);
        } else if (item.type.startsWith('video/')) {
          setFileType('video');
          const videoFile = item.getAsFile();
          handleUpLoad(videoFile);
        } else {
          const specialFile = item.getAsFile();
        }
      }
    };

    window.addEventListener('paste', handlePaste);
    return () => window.removeEventListener('paste', handlePaste);
  }, []);

  useEffect(() => {
    if (testStepRunID) {
      getTestStepRunDeatil();
    }
  }, [testStepRunID, isUpdateTestCase]);

  useEffect(() => {
    setIsOpen(!isOpen);
    setEndCallUpdate(false);
    window.localStorage.removeItem('open-modal');
    localStorage.removeItem('event');
    const urlParams = new URLSearchParams(location.search);
    const newTestStepID = urlParams.get('testStepRunID');
    setTestStepRunID(newTestStepID);
  }, []);

  return (
    <>
      <Modal
        className="execute-manual-test-case"
        open={isOpen}
        // onCancel={cancel}
        destroyOnClose={true}
        footer={null}
        closeIcon={''}
      >
        <Helmet>
          <title>Execute</title>
        </Helmet>
        {/* <Spin style={{ marginTop: ` ${!previewImage ? '20%' : '50%'}`, zIndex: 900 }}> */}
        <div className="test-case-steps__modal">
          <div className="add-new-defect-modal">
            <div className="border-0 mb-6">
              <div className="mt-5">
                <h3 className="add-new-modal__header" role="title">
                  {execuTetestCaseId} - {testCaseDetailTitle}
                </h3>
              </div>
            </div>

            <div className="test-case_modal_container">
              <Card>
                <Form
                  form={form}
                  // onFinish={onFinish}
                  className="release-detail__form layout-dashboard "
                  autoComplete="off"
                >
                  <Row className="" justify={'center'}>
                    <Col span={24}>
                      <span className="test-case__step_upload_title">Step ID: {testStepDeatil?.testStepId}</span>
                    </Col>
                    {previewImage && fileType === 'image' && (
                      <Col className="step_upload__item">
                        <Row className="attachment_preview_img">
                          {previewImage ? (
                            <Image
                              width={200}
                              height={200}
                              src={previewImage}
                              preview={false}
                              onDragOver={handleDragOver}
                              onDrop={handleDrop}
                            />
                          ) : null}
                        </Row>
                      </Col>
                    )}
                    {previewImage && fileType == 'video' && (
                      <div onDragOver={handleDragOver} onDrop={handleDrop}>
                        <video controls className="attachment-modal__image mb-20" width={350}>
                          <source src={previewImage} type="video/mp4" />
                          Your browser does not support the video tag.
                        </video>
                      </div>
                    )}
                    <Col span={24} className="test-case__step_upload">
                      <Row className="test-case__step_upload-contain">
                        <Form.Item
                          name="FileObject"
                          // rules={[{ required: !infoFileName, message: 'No File chosen.' }]}
                          htmlFor="attachment-modal__upload"
                          style={{ width: '100%' }}
                        >
                          <Upload
                            showUploadList={false}
                            beforeUpload={() => false}
                            onChange={handleChangeUpload}
                            accept="image/*,video/*"
                            id="attachment-modal__upload"
                            {...props}
                          >
                            <div className="ant-upload-drag">
                              <p className="ant-upload-drag-icon">
                                <InboxOutlined />
                              </p>
                              <div className="ant-upload-hint" style={{ color: '#5daad6' }}>
                                Drag & Drop or Browse
                              </div>
                              <div className="ant-upload-hint" style={{ color: '#5daad6' }}>
                                or Ctrl + V to paste from Clipboard
                              </div>
                              <p className="ant-upload-hint mb-10">Maximum upload file size: 75MB</p>
                              <p className="ant-upload-hint mb-10">Supported formats: PDF, JPG, JPEG, PNG, MOV, MP4</p>
                            </div>
                            {checkValidateFile && <span className="ant-form-item-explain-error">{errorText}</span>}
                          </Upload>
                        </Form.Item>
                      </Row>
                    </Col>
                  </Row>

                  <Row className="modal_container-action" gutter={[8, 8]}>
                    <Col style={{ marginTop: 15 }} span={12}>
                      <span className="test-case__step__title">Activity</span>
                      <TextArea
                        disabled
                        value={testStepDeatil?.testStepActivity}
                        rows={6}
                        autoSize={false}
                        style={{ resize: 'none' }}
                      />
                    </Col>
                    <Col style={{ marginTop: 15 }} span={12}>
                      <span className="test-case__step__title">Additional Information</span>
                      <TextArea
                        disabled
                        value={testStepDeatil?.testStepAdditionalInformation}
                        rows={6}
                        autoSize={false}
                        style={{ resize: 'none' }}
                      />
                    </Col>
                  </Row>

                  <Row className="modal_container-action" gutter={[12, 12]}>
                    <Col span={18}>
                      <Row style={{ width: '100%' }}>
                        <span className="test-case__step__title">Expected Result</span>
                        <TextArea
                          disabled
                          value={testStepDeatil?.testStepExpectedResult}
                          rows={6}
                          autoSize={false}
                          style={{ resize: 'none' }}
                        />
                      </Row>
                      <Row style={{ marginTop: 10, width: '100%' }}>
                        <span className="test-case__step__title">Actual Result</span>
                        <TextArea
                          id="execution-detail__textArea"
                          className="execution-detail__textArea"
                          onChange={handleChangeActualResult}
                          onBlur={handleBlurActualResult}
                          rows={4}
                          value={actualResult}
                        />
                        <div className="step_action-button__actual">
                          <Button
                            id="execution-test-step__prev"
                            disabled={!idPreviousStep}
                            onClick={() => handleNextOrPrevTestCase('prev')}
                            className={`button ${!idPreviousStep && 'button_prev'}`}
                          >
                            Prev Step
                          </Button>
                          <Button
                            onClick={openModalCreateDefect}
                            className={`button`}
                            id="execution-test-step__create-defect"
                          >
                            Create Defect
                          </Button>
                          <Button
                            id="execution-test-step__next"
                            disabled={!idNextTestStep}
                            onClick={() => handleNextOrPrevTestCase('next')}
                            className={`button ${!idNextTestStep && 'button_prev'}`}
                          >
                            Next Step
                          </Button>
                        </div>
                      </Row>
                    </Col>
                    <Col span={2} />
                    <Col span={4}>
                      <div className="step_action-button">
                        {statusTestStep.map((status, index) => {
                          return (
                            <>
                              <Button
                                loading={isLoading}
                                id={`execution-test-step__${status?.value}`}
                                key={index}
                                htmlType="submit"
                                className="button"
                                style={{ backgroundColor: status.color }}
                                onClick={() => handleChangeStatus(status?.name)}
                              >
                                {status?.name}
                              </Button>
                            </>
                          );
                        })}
                      </div>
                    </Col>
                  </Row>
                </Form>
              </Card>
            </div>
          </div>
        </div>
        {/* </Spin> */}
      </Modal>
    </>
  );
};

export default ExecuteTestCase;
